import { tryCatchHelper } from '../../../helpers';
import { CLEAR_ALL } from '../../../store/Types';
import { tiposEntidadEnums } from '../../../widgets/fields/TiposEntidadesField';
import { oneEntAjustesAction } from '../../entidad/ent_ajustes/EntAjustesAction';
import {
  ACTIVO_ENTIDADES,
  ALL_ENTIDADES,
  LOADING_ALL_ENTIDADES,
  SETTINGS_ENTIDADES,
} from './EntidadesReducer';
import {
  allEntidadesService,
  deleteEntidadesService,
  oneEntidadesService,
  saveEntidadesService,
} from './EntidadesService';

export const allEntidadesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ENTIDADES, payload: true });
    const res = await allEntidadesService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_ENTIDADES, payload: res.data });
      dispatch({ type: LOADING_ALL_ENTIDADES, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_ENTIDADES, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ENTIDADES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntidadesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
  isAjustes,
) => {
  try {
    const res = await saveEntidadesService(id, data);
    notify(res.data.message);
    if (!isAjustes) {
      await allEntidadesAction(dispatch, params);
    } else {
      await setActivoEntidadesAction(dispatch, res.data.data);
    }
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntidadesAction = async (dispatch, data) => {
  if (data) {
    await oneEntAjustesAction(dispatch, data.id);
  }
  dispatch({ type: ACTIVO_ENTIDADES, payload: data });
  dispatch({
    type: SETTINGS_ENTIDADES,
    payload: {
      isBanda: data ? data.tipoEntidad === tiposEntidadEnums[4].id : false,
    },
  });
  if (data === null) {
    dispatch({ type: CLEAR_ALL });
  }
};

export const oneEntidadesAction = async (dispatch, id) => {
  try {
    const res = await oneEntidadesService(id);
    await setActivoEntidadesAction(dispatch, res.data.data);
    return res.data.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntidadesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntidadesService(id);
    notify(res.data.message);
    await setActivoEntidadesAction(dispatch, null);
    await allEntidadesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
